import { render } from "./NavigationPage.vue?vue&type=template&id=9bbcacf4&scoped=true"
import script from "./NavigationPage.vue?vue&type=script&lang=js"
export * from "./NavigationPage.vue?vue&type=script&lang=js"

import "./NavigationPage.vue?vue&type=style&index=0&id=9bbcacf4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bbcacf4"]])

export default __exports__